// removed by extract-text-webpack-plugin
module.exports = {"alert-orange":"app-components-WarningMessage-__WarningMessage___1ZRdC","warning-icon":"app-components-WarningMessage-__WarningMessage___ZRb7b"};


//////////////////
// WEBPACK FOOTER
// ./app/components/WarningMessage/WarningMessage.css
// module id = 2225
// module chunks = 0